/**
 * Why the Start Timer window's Start button is still grey, or null when the
 * timer can start. Owner 2026-10-21 (Roadmap 1805): a work item is required,
 * a client alone is no longer enough (replaces Roadmap 1239's rule).
 */
export const startTimerProblem = (
  contact: { value?: string | null } | null | undefined,
  work: { value?: string | null } | null | undefined,
): string | null => {
  if (!contact?.value) return "Pick a client and a work item first";
  if (!work?.value) return "Pick a work item first";
  return null;
};
